module.exports = __webpack_public_path__ + "img/thumbnail_Blackbuck_j_leucistic.1ea153a3.png";